// English translation file
export const en = {
  // Common
  common: {
    close: 'Close',
    save: 'Save',
    cancel: 'Cancel',
    yes: 'Yes',
    no: 'No',
    minutes: 'min',
    hours: 'hours',
    days: 'days',
    donuts: 'Donuts',
  },

  // Timer
  timer: {
    work: 'Work',
    break: 'Break',
    start: 'Start',
    stop: 'Stop',
    sessionComplete: 'Session Complete!',
  },

  // Menu
  menu: {
    timerSettings: 'Timer Settings',
    audioSettings: 'Audio Settings',
    systemSettings: 'System Settings',
    restSettings: 'Goal Settings',
    stats: 'Statistics',
    appInfo: 'App Info',
  },

  // Tool buttons
  tools: {
    stats: 'Stats',
    dress: 'Dress Up',
    camera: 'Camera',
    bgm: 'BGM',
  },

  // Settings
  settings: {
    workDuration: 'Work Duration',
    breakDuration: 'Break Duration',
    autoStart: 'Auto Start',
    bgmVolume: 'BGM Volume',
    seVolume: 'SE Volume',
    weatherEnabled: 'Weather Display',
    language: 'Language',
  },

  // Stats
  stats: {
    todayWorkTime: "Today's Work Time",
    totalWorkTime: 'Total Work Time',
    currentStreak: 'Current Streak',
    longestStreak: 'Longest Streak',
    level: 'Level',
    totalDonuts: 'Total Donuts',
  },

  // Messages (Sora-chan)
  messages: {
    // Morning greetings
    morningGreeting: [
      "Good morning! Let's do our best today!",
      'Good morning! Did you sleep well?',
      'Good morning! What kind of day will it be?',
    ],
    // Praise
    praise: [
      'Great job!',
      'Amazing!',
      'Well done!',
      'Good work!',
    ],
    // Encouragement
    encourage: [
      "Don't push yourself too hard",
      'Even 1 minute is great!',
      'Take your time',
      'Rest is important too',
    ],
    // Weather
    weatherSunny: "Nice weather today! But don't overdo it",
    weatherRainy: "Rainy days are for taking it slow",
    weatherCloudy: "Cloudy days can be gloomy. Be gentle with yourself",
  },

  // App Info
  appInfo: {
    version: 'Version',
    developer: 'Developer',
    concept: 'Concept',
    antiProductivity: "World's First Anti-Productivity Pomodoro App",
    philosophy: 'Mental health over productivity',
  },
};